module.exports = __webpack_public_path__ + "51fa9dd28e74be3048db15ae1326d8e4.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/adelle_bold-webfont.eot
// module id = 224
// module chunks = 0